import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of} from "rxjs";
import {EventPaymentSettingsService} from "@services";
import {EventPaymentSettings} from "@model";

export const EventPaymentSettingsResolver: ResolveFn<Observable<EventPaymentSettings | null> |
  Promise<EventPaymentSettings> | EventPaymentSettings> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   paymentSettingsSerivce: EventPaymentSettingsService = inject(EventPaymentSettingsService)): Observable<EventPaymentSettings | null> |
    Promise<EventPaymentSettings> | EventPaymentSettings => {
    let eventId = route.queryParams["eventId"];
    let currentPath: string | undefined = route.routeConfig?.path;

    if (!eventId) {
      return of(eventId);
    } else {
      if (currentPath === 'edit' || currentPath === 'copy') {
        return paymentSettingsSerivce.fetchEventPaymentSettingsById(+route.queryParams['eventId']);
      } else {
        return of(null);
      }
    }
  }
